/* src/app/components/add-promocode-modal/add-promocode-modal.component.scss */
.wrapper {
  position: relative;
  padding: 35px 0px 10px;
  text-align: center;
}
.wrapper .cross {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
  cursor: pointer;
}
.wrapper .title {
  text-transform: uppercase;
  padding-bottom: 10px;
}
.wrapper .promo-img {
  margin: 0 auto;
  width: 150px;
  height: 150px;
  border: 1px solid var(--color-black);
  background: #F48B7F;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper .promo-img ion-icon {
  width: 90px;
  height: 90px;
}
.wrapper .input-section {
  padding: 0px 25px;
}
.wrapper .input-section ion-input {
  border-radius: 26px;
  border: 1px solid var(--color-black);
  --padding-start: 10px;
  --padding-end: 10px;
}
.wrapper .input-section {
  margin-bottom: 15px;
}
.wrapper .description {
  padding: 12px;
  text-transform: uppercase;
  padding: 20px;
}
.footer {
  padding-top: 10px;
  border-top: 1px solid var(--color-black);
}
.footer ion-button {
  width: 90%;
}
.error-message {
  color: #b30101;
  padding: 10px;
  font-size: 12px;
}
/*# sourceMappingURL=add-promocode-modal.component.css.map */
